/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getRegimen } from 'app/entities/regimen/regimen.reducer';
import { getEntities as getRegimenDrugs } from 'app/entities/regimen-drug/regimen-drug.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { createEntity, getEntity, reset, updateEntity } from './regimen-adverse-event.reducer';

export const RegimenAdverseEventUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const regimen = useAppSelector(state => state.regimen.entities);
  const regimenDrugs = useAppSelector(state => state.regimenDrug.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const regimenAdverseEventEntity = useAppSelector(state => state.regimenAdverseEvent.entity);
  const loading = useAppSelector(state => state.regimenAdverseEvent.loading);
  const updating = useAppSelector(state => state.regimenAdverseEvent.updating);
  const updateSuccess = useAppSelector(state => state.regimenAdverseEvent.updateSuccess);

  const handleClose = () => {
    navigate(`/regimen-adverse-event${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getRegimen({}));
    dispatch(getRegimenDrugs({}));
    dispatch(getClinicalDictionaries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...regimenAdverseEventEntity,
      ...values,
      regimen: regimen.find(it => it.id.toString() === values.regimen?.toString()),
      drug: regimenDrugs.find(it => it.id.toString() === values.drug?.toString()),
      adverseEffectType: clinicalDictionaries.find(it => it.id.toString() === values.adverseEffectType?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...regimenAdverseEventEntity,
          regimen: regimenAdverseEventEntity?.regimen?.id,
          drug: regimenAdverseEventEntity?.drug?.id,
          adverseEffectType: regimenAdverseEventEntity?.adverseEffectType?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.regimenAdverseEvent.home.createOrEditLabel" data-cy="RegimenAdverseEventCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.regimenAdverseEvent.home.createOrEditLabel">
              Create or edit a RegimenAdverseEvent
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="regimen-adverse-event-id"
                  label={translate('tinyMedicRestApp.regimenAdverseEvent.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenAdverseEvent.description')}
                id="regimen-adverse-event-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenAdverseEvent.monitoringParameters')}
                id="regimen-adverse-event-monitoringParameters"
                name="monitoringParameters"
                data-cy="monitoringParameters"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenAdverseEvent.mitigationStrategies')}
                id="regimen-adverse-event-mitigationStrategies"
                name="mitigationStrategies"
                data-cy="mitigationStrategies"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenAdverseEvent.adverseEventInstructions')}
                id="regimen-adverse-event-adverseEventInstructions"
                name="adverseEventInstructions"
                data-cy="adverseEventInstructions"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenAdverseEvent.severity')}
                id="regimen-adverse-event-severity"
                name="severity"
                data-cy="severity"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenAdverseEvent.active')}
                id="regimen-adverse-event-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenAdverseEvent.cursor')}
                id="regimen-adverse-event-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenAdverseEvent.lastUpdated')}
                id="regimen-adverse-event-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenAdverseEvent.microSec')}
                id="regimen-adverse-event-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimenAdverseEvent.timestampEntry')}
                id="regimen-adverse-event-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="regimen-adverse-event-regimen"
                name="regimen"
                data-cy="regimen"
                label={translate('tinyMedicRestApp.regimenAdverseEvent.regimen')}
                type="select"
              >
                <option value="" key="0" />
                {regimen
                  ? regimen.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="regimen-adverse-event-drug"
                name="drug"
                data-cy="drug"
                label={translate('tinyMedicRestApp.regimenAdverseEvent.drug')}
                type="select"
              >
                <option value="" key="0" />
                {regimenDrugs
                  ? regimenDrugs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="regimen-adverse-event-adverseEffectType"
                name="adverseEffectType"
                data-cy="adverseEffectType"
                label={translate('tinyMedicRestApp.regimenAdverseEvent.adverseEffectType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/regimen-adverse-event" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RegimenAdverseEventUpdate;
